module.exports = __webpack_public_path__ + "img/radio-muzik-fm.dfbd0643.png";